// The fixed ground layer (tokens.css .atmosphere): gradients plus the vein mask, no filters.
// Submit and full-page states only; data pages are the flat sheet.
//   <Atmosphere />
export function Atmosphere() {
  return <div className="atmosphere" aria-hidden="true" />;
}
